{
	"translateAcquirerTansactionType": {
		"credit": "Credit",
		"debit": "Debit"
	}
}
